import TextButton from "@components/buttons/TextButton"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body16MainStyles, h2Styles, h4Styles } from "@constants/typography"
import React from "react"
import styled from "styled-components"

import Modal, { ModalBaseProps } from "../index"

const Container = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 48px;

  @media ${breakpoints.laptop} {
    height: 100%;
    align-items: flex-start;
    margin-left: calc(1 / 12 * 100vw);
    padding: 0;
    text-align: left;
  }
`

const Title = styled.h2`
  ${h4Styles}
  margin: 0;
  color: ${colors.black};
  @media ${breakpoints.laptop} {
    ${h2Styles}
    color: ${colors.black};
    margin: 0;
  }
`

const Subtitle = styled.div`
  ${body16MainStyles}
  color: ${colors.mediumDarkGray};
  margin-top: 25px;
`

const BackButton = styled(TextButton)`
  margin-top: calc(3 / 12 * 100vh);
  width: 100%;

  @media ${breakpoints.laptop} {
    margin-top: 50px;
    width: 280px;
  }
`

interface RequestReceivedModalProps extends ModalBaseProps {}

const RequestReceivedModal = (props: RequestReceivedModalProps) => (
  <Modal {...props}>
    <Container>
      <Title>Thanks!</Title>
      <Subtitle>We received your request and we'll be in touch soon!</Subtitle>
      <BackButton onClick={props.onRequestClose} text="Done" />
    </Container>
  </Modal>
)

export default RequestReceivedModal
